import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_TENANT_ACKNOWLEDGEMENT_Mapper extends BaseFormMapper<HOME_TRUST_TENANT_ACKNOWLEDGEMENT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_TENANT_ACKNOWLEDGEMENT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_TENANT_ACKNOWLEDGEMENT);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_TENANT_ACKNOWLEDGEMENT> {
		return {};
	}
}

const Mappings: HOME_TRUST_TENANT_ACKNOWLEDGEMENT = {
	// "0":"F[0]",
	// "1":"F[0].P1[0]",
	unitOccupiedBy2: 'F[0].P1[0].TextField1[33]',
	unitOccupiedBy1: 'F[0].P1[0].TextField1[32]',
	agreements2: 'F[0].P1[0].TextField1[31]',
	agreements1: 'F[0].P1[0].TextField1[30]',
	leaseAmount: 'F[0].P1[0].TextField1[29]',
	leaseExpiryDateYear: 'F[0].P1[0].TextField1[28]',
	leaseExpiryDateMonth: 'F[0].P1[0].TextField1[27]',
	leaseExpiryDateDay: 'F[0].P1[0].TextField1[26]',
	// "10":"F[0].P1[0].ResetButton1[0]",
	dateTo: 'F[0].P1[0].TextField1[25]',
	dateYear: 'F[0].P1[0].TextField1[24]',
	dateMonth: 'F[0].P1[0].TextField1[23]',
	dateDay: 'F[0].P1[0].TextField1[22]',
	stoveOwnedByTenant: 'F[0].P1[0].CheckBox1[5]',
	stoveOwnedByLandlord: 'F[0].P1[0].CheckBox1[4]',
	refrigeratorOwnedByLandlord: 'F[0].P1[0].CheckBox1[3]',
	refrigeratorOwnedByTenant: 'F[0].P1[0].CheckBox1[2]',
	verbalAgreementBasedTenancy: 'F[0].P1[0].CheckBox1[1]',
	leaseBasedTenancy: 'F[0].P1[0].CheckBox1[0]',
	depositAmount: 'F[0].P1[0].TextField1[21]',
	depositDateYear: 'F[0].P1[0].TextField1[20]',
	depositDateMonth: 'F[0].P1[0].TextField1[19]',
	depositDateDay: 'F[0].P1[0].TextField1[18]',
	rentalRateTo: 'F[0].P1[0].TextField1[17]',
	rentalRateDateYear: 'F[0].P1[0].TextField1[16]',
	rentalRateDateMonth: 'F[0].P1[0].TextField1[15]',
	rentalRateDateDay: 'F[0].P1[0].TextField1[14]',
	rentalRate: 'F[0].P1[0].TextField1[13]',
	possessionDateYear: 'F[0].P1[0].TextField1[12]',
	possessionDateMonth: 'F[0].P1[0].TextField1[11]',
	possessionDateDay: 'F[0].P1[0].TextField1[10]',
	otherAddtionalAmountPaidByTenant: 'F[0].P1[0].TextField1[9]',
	additionalAmountPaidByTenant: 'F[0].P1[0].TextField1[8]',
	prepaidRentDepositAndDate: 'F[0].P1[0].TextField1[7]',
	rentPaidTo: 'F[0].P1[0].TextField1[6]',
	dateOfLastPayment: 'F[0].P1[0].TextField1[5]',
	paymentDates: 'F[0].P1[0].TextField1[4]',
	rentalPayment: 'F[0].P1[0].TextField1[3]',
	apartmentNumber: 'F[0].P1[0].TextField1[2]',
	propertyAddress: 'F[0].P1[0].TextField1[1]',
	landlord: 'F[0].P1[0].TextField1[0]',
	// "43":"F[0].P1[0].PrintButton1[0]"
};

export interface HOME_TRUST_TENANT_ACKNOWLEDGEMENT {
	landlord: string;
	propertyAddress: string;
	apartmentNumber: string;
	rentalPayment: string;
	paymentDates: string;
	dateOfLastPayment: string;
	rentPaidTo: string;
	prepaidRentDepositAndDate: string;
	additionalAmountPaidByTenant: string;
	otherAddtionalAmountPaidByTenant: string;

	possessionDateDay: string;
	possessionDateMonth: string;
	possessionDateYear: string;
	rentalRate: string;

	rentalRateDateDay: string;
	rentalRateDateMonth: string;
	rentalRateDateYear: string;
	rentalRateTo: string;
	depositDateDay: string;
	depositDateMonth: string;
	depositDateYear: string;
	depositAmount: string;

	leaseBasedTenancy: string;
	verbalAgreementBasedTenancy: string;

	leaseExpiryDateDay: string;
	leaseExpiryDateMonth: string;
	leaseExpiryDateYear: string;
	leaseAmount: string;

	refrigeratorOwnedByLandlord: string;
	refrigeratorOwnedByTenant: string;

	stoveOwnedByLandlord: string;
	stoveOwnedByTenant: string;

	agreements1: string;
	agreements2: string;

	unitOccupiedBy1: string;
	unitOccupiedBy2: string;

	dateDay: string;
	dateMonth: string;
	dateYear: string;
	dateTo: string;
}
